import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, Clock, UtensilsCrossed, Zap, ShieldAlert } from 'lucide-react';
export function WhySupplementsFail() {
  return <Section className="bg-primary text-cream rounded-3xl my-12" data-id="element-245">
      <div className="max-w-4xl mx-auto" data-id="element-246">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 text-white" data-id="element-247">
          Why Most Supplements Fail to Deliver Results
        </h2>

        <p className="text-xl text-center text-cream/90 mb-12 max-w-2xl mx-auto" data-id="element-248">
          The truth is, a supplement can be “good” and still not work well if
          you take it the wrong way.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-249">
          <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/10 flex items-start gap-4" data-id="element-250">
            <UtensilsCrossed className="text-sage-light shrink-0 mt-1" size={24} data-id="element-251" />
            <p className="text-lg" data-id="element-252">
              Some supplements need to be taken with food, while others are
              better on an empty stomach.
            </p>
          </div>

          <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/10 flex items-start gap-4" data-id="element-253">
            <Zap className="text-sage-light shrink-0 mt-1" size={24} data-id="element-254" />
            <p className="text-lg" data-id="element-255">
              Some nutrients work better together, while others compete for
              absorption.
            </p>
          </div>

          <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/10 flex items-start gap-4 md:col-span-2 md:max-w-2xl md:mx-auto" data-id="element-256">
            <ShieldAlert className="text-sage-light shrink-0 mt-1" size={24} data-id="element-257" />
            <p className="text-lg" data-id="element-258">
              And even the best supplement can be a waste of money if the brand
              is low quality.
            </p>
          </div>
        </div>

        <div className="text-center bg-white/5 p-8 rounded-2xl border border-white/20" data-id="element-259">
          <p className="text-xl md:text-2xl font-serif mb-4" data-id="element-260">
            That means the problem may not be that supplements “don’t work”…
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-sage-light" data-id="element-261">
            The problem may be that nobody showed you how to use them properly.
          </p>
          <p className="mt-6 text-lg text-cream/80 uppercase tracking-wider font-semibold" data-id="element-262">
            That’s exactly why this guide exists.
          </p>
        </div>
      </div>
    </Section>;
}